/* eslint-disable eqeqeq */

/**
 * Merge user options with default options (without mutating defaults)
 * @param {Object} defaultOptions - Default options object
 * @param {Object} userOptions - User-provided options to merge
 * @returns {Object} Merged options object
 */
export const mergeOptions = (defaultOptions, userOptions) => {
    const options = { ...defaultOptions };

    for (const prop in userOptions) {
        if (userOptions[prop] && Object.hasOwn(options, prop))
            options[prop] = userOptions[prop];
    }

    return options;
};

/**
 * Throttle function execution to limit calls to once per specified interval
 * @param {Function} func - Function to throttle
 * @param {number} limit - Minimum time between calls in milliseconds
 * @returns {Function} Throttled function
 */
export const throttle = (func, limit) => {
    let inThrottle;
    return function (...args) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
        }
    };
};

export const serializeArray = (form) => {
    let field;
    let l;
    const s = [];

    if (typeof form === 'object' && form.nodeName == 'FORM') {
        const len = form.elements.length;

        for (let i = 0; i < len; i++) {
            field = form.elements[i];

            if (
                field.name &&
                !field.disabled &&
                field.type != 'file' &&
                field.type != 'reset' &&
                field.type != 'submit' &&
                field.type != 'button'
            ) {
                if (field.type == 'select-multiple') {
                    l = form.elements[i].options.length;
                    for (let j = 0; j < l; j++) {
                        if (field.options[j].selected)
                            s[s.length] = {
                                name: field.name,
                                value: field.options[j].value,
                            };
                    }
                } else if (
                    (field.type != 'checkbox' && field.type != 'radio') ||
                    field.checked
                ) {
                    s[s.length] = { name: field.name, value: field.value };
                }
            }
        }
    }

    return s;
};
